export default "__VITE_ASSET__oU0PGsXQ__"